import { Badge, Card, Col, Row } from "react-bootstrap"
import { PersonFill } from "react-bootstrap-icons"
import timeService from "../../services/time/timeService"

interface ProfileInformationProps {
  username?: string
  firstName?: string
  lastName?: string
  profilePic?: string
  phone?: string
  role?: string
  lastLogin?: string | number
}

export default function ProfileInformation({
  username,
  firstName,
  lastName,
  profilePic,
  phone,
  role,
  lastLogin
}: ProfileInformationProps) {
  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title className="mb-0">Profile Information</Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs={12} md={3} className="text-center mb-3">
            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: '150px', height: '150px', border: '2px solid #eee', overflow: 'hidden', margin: '0 auto', backgroundColor: '#f8f9fa' }}>
              {profilePic ? (
                <img src={profilePic} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <PersonFill size={60} color="#6c757d" />
              )}
            </div>
          </Col>
          <Col xs={12} md={9}>
            <Row className="mb-2">
              <Col sm={4} md={2}><strong>Username:</strong></Col>
              <Col sm={8}>{username || 'N/A'}</Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4} md={2}><strong>Name:</strong></Col>
              <Col sm={8}>{firstName || ''} {lastName || ''}</Col>
            </Row>
            <Row className="mb-2">
              <Col sm={4} md={2}><strong>Role:</strong></Col>
              <Col sm={8}>
                <Badge bg="primary">{role || 'Unknown'}</Badge>
              </Col>
            </Row>
            {phone && (
              <Row className="mb-2">
                <Col sm={4} md={2}><strong>Phone:</strong></Col>
                <Col sm={8}>{phone}</Col>
              </Row>
            )}
            {lastLogin && (
              <Row className="mb-2">
                <Col sm={4} md={2}><strong>Last Login:</strong></Col>
                <Col sm={8}>{timeService.getFormattedTime(new Date(lastLogin))}</Col>
              </Row>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}